export const CLIENT_PROFILE_PICTURE_TYPE = 'client_profile_pictures';

export const getClientProfilePictureFolder = (ownerId, clientId) => {
    return `${ownerId}/${CLIENT_PROFILE_PICTURE_TYPE}/${clientId}`;
};

export class FileComponents {
    constructor(path) {
        this.getOwnerId = this.getOwnerId.bind(this);
        this.getType = this.getType.bind(this);
        this.getFolder = this.getType.bind(this);
        this.getName = this.getName.bind(this);
        this.getCaseId = this.getCaseId.bind(this);
        this.getClientId = this.getClientId.bind(this);
        this.isCaseFile = this.isCaseFile.bind(this);
        this.isTemplateFile = this.isTemplateFile.bind(this);
        this.isSignedDocFile = this.isSignedDocFile.bind(this);
        this.isClientProfilePictureFile = this.isClientProfilePictureFile.bind(this);

        this.components = (path || '').replace(/\/\//g, '/').split('/');
        if (this.components.length > 0) {
            this.ownerId = parseInt(this.components[0]);
            this.type = this.components[1]; // template, case, or client_profile_pictures
            if (this.type == 'case') {
                this.caseId = parseInt(this.components[2]);
                this.name = this.components[4];
                this.folder = this.components[3];
            } else if (this.type == CLIENT_PROFILE_PICTURE_TYPE) {
                this.clientId = parseInt(this.components[2]);
                this.name = this.components[3];
                this.folder = this.type;
            } else {
                this.name = this.components[3];
                this.folder = this.components[2];
            }
        }
    }

    getOwnerId() {
        return this.ownerId;
    }

    getType() {
        return this.type;
    }

    getFolder() {
        return this.folder;
    }

    getName() {
        return this.name;
    }

    getCaseId() {
        return this.caseId;
    }

    getClientId() {
        return this.clientId;
    }

    isCaseFile() {
        return this.type === 'case' && this.folder === 'notes';
    }

    isTemplateFile() {
        return this.type === 'template';
    }

    isSignedDocFile() {
        return this.type === 'case' && this.folder === 'signed_docs';
    }

    isClientProfilePictureFile() {
        return this.type === CLIENT_PROFILE_PICTURE_TYPE;
    }
}
